import React from 'react';
import { StyleSheet, View } from 'react-native';
import BMBadgeTag from '../BadgeTag/BMBadgeTag';
import { getBadgeStyle } from '../BadgeTag/variants';
import { useBMTheme } from '../../theme';
import { BMBadgeCornerRibbonContext } from './context';
import { BMPrimitives } from '../../theme';
const BMBadgeCornerRibbon = (props) => {
    const { position, ...badgeProps } = props;
    const { BMComponents } = useBMTheme();
    const badgeTagStyle = getBadgeStyle(badgeProps.type, BMComponents);
    const getRibbonStyle = () => {
        switch (position) {
            case 'TOP_LEFT':
                return [styles.ribbonTopLeft, { borderRightColor: badgeTagStyle.color }];
            case 'TOP_RIGHT':
                return [styles.ribbonTopRight, { borderLeftColor: badgeTagStyle.color }];
            case 'BOTTOM_LEFT':
                return [styles.ribbonBottomLeft, { borderRightColor: badgeTagStyle.color }];
            case 'BOTTOM_RIGHT':
                return [styles.ribbonBottomRight, { borderLeftColor: badgeTagStyle.color }];
        }
    };
    return (<View style={[
            styles.cornerRibbonContainer,
            { flexDirection: position.includes('BOTTOM') ? 'column' : 'column-reverse' },
        ]}>
      <View style={[styles.ribbonContainer, { justifyContent: position.includes('LEFT') ? 'flex-start' : 'flex-end' }]}>
        <View style={getRibbonStyle()}></View>
      </View>
      <BMBadgeCornerRibbonContext.Provider value={{ position }}>
        <BMBadgeTag {...badgeProps}/>
      </BMBadgeCornerRibbonContext.Provider>
    </View>);
};
const styles = StyleSheet.create({
    cornerRibbonContainer: {
        display: 'flex',
        marginVertical: 'auto',
        zIndex: 10,
    },
    ribbonContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    ribbonBottomLeft: {
        borderTopColor: 'transparent',
        borderTopWidth: BMPrimitives.BMSize.sm,
        borderRightWidth: BMPrimitives.BMSize.sm,
    },
    ribbonBottomRight: {
        borderTopColor: 'transparent',
        borderTopWidth: BMPrimitives.BMSize.sm,
        borderLeftWidth: BMPrimitives.BMSize.sm,
    },
    ribbonTopRight: {
        borderBottomColor: 'transparent',
        borderBottomWidth: BMPrimitives.BMSize.sm,
        borderLeftWidth: BMPrimitives.BMSize.sm,
    },
    ribbonTopLeft: {
        borderBottomColor: 'transparent',
        borderBottomWidth: BMPrimitives.BMSize.sm,
        borderRightWidth: BMPrimitives.BMSize.sm,
    },
});
export default BMBadgeCornerRibbon;
